// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"fad118da","225":"304ef213","773":"f833672e","787":"30e7697e","936":"ffebe3eb"}[chunkId] + ".chunk.js";
};